import {ProductDataStore} from "../../stores/productDataStore";
import {ProductDataService} from "../../services/productDataService";
import {PacketRuleService} from "../../services/packetRuleService";
import {AppStateService} from "../../services/appStateService";
import {UIService} from "../UIService";
import {AccessoryService} from "../accessoryComponent/accessoryService";
import {AccessoryRuleService} from "../../services/accessoryRuleService";
import {PriceFormatter} from "../../services/priceFormatter";
import {DrawingDataService} from "../drawingComponent/drawingDataService";

export class PacketService
{
    public name: string;
    private productDataStore: ProductDataStore;
    private packetRuleService: PacketRuleService;
    private appStateService: AppStateService;
    private uiService: UIService;
    private productDataService: ProductDataService;
    private accessoryService: AccessoryService;
    private accessoryRuleService: AccessoryRuleService;
    private priceFormatter: PriceFormatter;
    private drawingsDataService: DrawingDataService;

    constructor()
    {
        this.name = 'packet';
        this.productDataStore = new ProductDataStore();
        this.productDataService = new ProductDataService();
        this.packetRuleService = new PacketRuleService();
        this.appStateService = new AppStateService();
        this.uiService = new UIService();
        this.accessoryService = new AccessoryService();
        this.accessoryRuleService = new AccessoryRuleService();
        this.priceFormatter = new PriceFormatter();
        this.drawingsDataService = new DrawingDataService();
    }

    public validate() {
        this.productDataStore.updatePacketsAvailability(
            this.accessoryRuleService.validate().packets
        );
    }

    public static getPacketAccessories(packet) {
        if (!packet.relationships ||
            !packet.relationships.accessories ||
            !packet.relationships.accessories.data
        ) {
            return [];
        }
        const productDataStore = new ProductDataStore();
        const availableAccessories = productDataStore.getAvailableOptionsByName('accessory');

        return packet.relationships.accessories.data.map(
            packetAccessory => availableAccessories.find(
                accessory => Number(accessory.id) === Number(packetAccessory.id)
            )
        ).filter(Boolean);
    }

    public static getSelectedPacketsAccessories() {
        let accessoriesIds = [];
        const productDataStore = new ProductDataStore();
        const selectedPackets = productDataStore.getSelectedOptionByName('packet');

        selectedPackets.forEach((selectedPacket) => {
            const packetDetails = productDataStore.getAvailableOptionByNameAndId(
                'packet',
                selectedPacket.id
            );
            if (packetDetails.relationships.accessories.data) {
                packetDetails.relationships.accessories.data.forEach((accessory) => {
                    accessoriesIds.push(accessory.id);
                });
            }
        });
        return accessoriesIds;
    }

    public static isAnyPacketSelected()
    {
        const selectedPackets = new ProductDataStore().getSelectedOptionByName('packet');

        return Object.entries(selectedPackets).length > 0;
    }

    public toggle(id)
    {
        let selectedPackets = this.productDataStore.getSelectedOptionByName('packet');
        const toggledPacket = this.productDataStore.getAvailableOptionByNameAndId('packet', id);

        if (this.productDataStore.isSelected('packet', id)) {
            selectedPackets = selectedPackets.filter(function(packet) {
                return packet.id != id;
            });
            if (toggledPacket.relationships.handle) {
                const initialHandle = this.productDataStore.getInitialOptionByName('handle');
                this.productDataStore.updateSelectedOption('handle', initialHandle.id);
            }
            if (toggledPacket.relationships.glazingSpacers) {
                const initialGlazingSpacers = this.productDataStore.getInitialOptionByName('glazingSpacer');
                this.productDataStore.updateSelectedOption('glazingSpacer', initialGlazingSpacers.id);
            }
            if (toggledPacket.relationships.accessories.data) {
                toggledPacket.relationships.accessories.data.forEach((accessory) => {
                    this.accessoryService.remove(accessory.id);
                });
            }
        } else {
            selectedPackets.push({
                'id': id,
                'type': this.name,
            });
            if (toggledPacket.relationships.handle) {
                this.productDataService.updateHandle(toggledPacket.relationships.handle.data.id);
            }
            if (toggledPacket.relationships.glazingSpacers) {
                this.productDataService.updateSelectedOptionByName('glazingSpacers', toggledPacket.relationships.glazingSpacers.data.id, true);
            }
            if (toggledPacket.relationships.accessories.data) {
                toggledPacket.relationships.accessories.data.forEach((accessory) => {
                    this.accessoryService.select(accessory.id);
                });
            }
        }
        this.productDataService.updateSelectedOptionByName('packet', selectedPackets, true);

        return selectedPackets;
    }

    public reset() {
        const packets = this.productDataStore.getSelectedOptionByName('packet');
        this.productDataStore.updateSelectedOption('packet', []);

        packets.forEach((packet) => {
            const packetDetails = this.productDataStore.getAvailableOptionByNameAndId(
                'packet',
                packet.id
            );
            if (packetDetails.relationships.accessories.data) {
                packetDetails.relationships.accessories.data.forEach((accessory) => {
                    this.accessoryService.remove(accessory.id);
                });
            }
        });
    }

    public getGlazingSpacerPrice(priceAfterDiscount: number): string {
        return this.priceFormatter.getPriceWithCurrency(this.drawingsDataService.getGlassSquareMeterArea() * priceAfterDiscount, false);
    }
}
